import Swiper, { Autoplay, Pagination, Navigation, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { animate, scroll } from "motion"

var scrollMem = 0;

const fireEvent = function (category, action, label) {
	action = action.toLowerCase() || 'click';
	label = label != null ? String(label).replace(/\s+/g, ' ').trim() : '';
	if (typeof gtag === 'function') {
		gtag('event', action, {
			'event_category': category,
			'event_label': label,
			'event_name': action,
			// link_text maps to GA4's built-in "linkText" dimension (no custom dimension needed),
			// which the analytics dashboard reads for its Label column.
			'link_text': label,
			'transport_type': 'beacon'
		});
		console.log('GA4 event fired:', category, label);
	} else if (typeof ga !== 'undefined') {
		ga('send', 'event', category, action, label);
		console.log('UA event fired:', category, label);
	} else {
		console.error('Google Analytics not found. Event not tracked for file:', category, label);
	}
}

const onResize = function() {

	const header = document.querySelector("header");
	const headerSpacer = document.querySelector('#headerSpacer');
	if (header && headerSpacer) {
		headerSpacer.style.height = (header.clientHeight + 32) + 'px';
	}

	document.querySelectorAll(".main>ul>li>ul.sub-menu").forEach(function (sm) {
		if (sm.classList.contains("scrollable")) {
			sm.style.height = "auto";
			sm.classList.remove("scrollable");
		}
	});

};

document.addEventListener('DOMContentLoaded', function() {

	document.querySelectorAll("#news .switches a").forEach(function(switchEl) {
		console.log(switchEl);
		switchEl.addEventListener("click", function() {
			document.querySelector("#news .switches a.active").classList.remove("active");
			this.classList.add("active");
			document.querySelector("#news .newsBoxes.active").classList.remove("active");
			document.querySelector("#news .newsBoxes." + this.dataset.block).classList.add("active");
		});
	});

	new Swiper("#testimonialsInner .swiper-container", {
        modules: [Autoplay, Pagination, Navigation],
		autoplay: {
			delay: 10000
		},
		loop: true,
		pagination: {
			el: '#testimonials .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '#testimonials .swiper-button-next',
			prevEl: '#testimonials .swiper-button-prev',
		},
	});

	document.querySelectorAll('.accordion.hasContent').forEach(function(accordion) {
		accordion.addEventListener('click', function(e) {
			var keepOthers = accordion.dataset.keepOthers === 'true';
			if(keepOthers && accordion.classList.contains('show')) {
				accordion.classList.remove('show');
				accordion.nextElementSibling.style.height = 0;
				scrollMem = 0;
			} else if(keepOthers) {
				accordion.classList.add('show');
				var pageTitle = document.title;
				var label = accordion.querySelector('span');
				label = (label ? label.innerText : 'No title') + ' on ' + pageTitle;
				fireEvent('Accordion', 'open', label);
				accordion.nextElementSibling.style.height = accordion.nextElementSibling.querySelector('div.inner').clientHeight + 'px';
			} else if(accordion.classList.contains('show')) {
				document.querySelectorAll('.accordion').forEach(function(h2) {
					h2.classList.remove('show');
				});
				document.querySelectorAll('div.accordion').forEach(function(div) {
					div.style.height = 0;
				});
				scrollMem = 0;
			} else {
				document.querySelectorAll('.accordion').forEach(function(h2) {
					h2.classList.remove('show');
				});
				document.querySelectorAll('div.accordion').forEach(function(div) {
					div.style.height = 0;
				});
				window.setTimeout(function() {
				accordion.classList.add('show');
				var pageTitle = document.title;
				var label = accordion.querySelector('span');
				label = (label ? label.innerText : 'No title') + ' on ' + pageTitle;
				fireEvent('Accordion', 'open', label);
				var beHeight = accordion.nextElementSibling.querySelector('div.inner').clientHeight;
				accordion.nextElementSibling.style.height = beHeight + 'px';
				if(true) {
					scrollMem = window.scrollY;
					var st = accordion.getBoundingClientRect().top+window.scrollY;	
					var sb = accordion.getBoundingClientRect().bottom+beHeight;
					var stO = 0;
					if(document.getElementById("afterHeader")) {
						stO = document.querySelector("#afterHeader").getBoundingClientRect().top;
					}
					if(sb > window.innerHeight) {
						window.scrollTo({
							top: st - stO - 20 - document.querySelector("header").clientHeight,
							behavior: 'smooth'
						});
					}
				}},400);
			}
		});
	});

	document.querySelectorAll('#headerBilder.swiper-container:not(:has(.swiper-slide:only-child))').forEach(function(swiperEl) {
		let options = {
			modules: [Autoplay, EffectFade],
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
			},
		loop: true };
		if(swiperEl.classList.contains('one-text-only')) {
			options.effect = 'fade';
			options.fadeEffect = { crossFade: true };
		}
		let headerSwiper =  new Swiper(swiperEl,options );
		headerSwiper.on('slideChange', () => {
			const current = headerSwiper.slides[headerSwiper.activeIndex];
			const duration = current.dataset.duration || 2000;
			console.log('slide changed', duration);
			headerSwiper.params.autoplay.delay = parseInt(duration);
			headerSwiper.autoplay.start();
		});  
	});

	document.addEventListener('scroll', function() {
		var cta = document.querySelector("#cta");
		var contactCta = document.querySelector(".contact-cta");
		if (!cta || !contactCta) return;
		var scrollTop = window.scrollY;
		var footerTop = cta.getBoundingClientRect().top;
		if(scrollTop > 0 && footerTop > window.innerHeight) {
			contactCta.classList.add("scrolled");
		} else {
			contactCta.classList.remove("scrolled");
		}
	});

	if(typeof openImmediately !== 'undefined') {
		jQuery("#job_"+openImmediately).click();
	};

    var trigger = document.getElementById("trigger");
    if (trigger) {
        trigger.addEventListener("click", function () {
            var el = document.getElementById("trigger");
            var mobileMenu = document.getElementById("mobile_menu");
            if (el.classList.contains("open")) {
                el.classList.remove("open");
                document.querySelector("body").classList.remove("scroll-lock");
                if (mobileMenu) mobileMenu.classList.remove("open");
            } else {
                el.classList.add("open");
                document.querySelector("body").classList.add("scroll-lock");
                if (mobileMenu) mobileMenu.classList.add("open");
            }
        });
    }

	window.setInterval(function() {
		if(window.outerWidth < 800) {
			return;
		}
		document.querySelectorAll(".main>ul>li>ul.sub-menu").forEach(function(sm) {
			if(sm.style.display != 'none') {
				var smBottom = sm.getBoundingClientRect().bottom;
				if(smBottom > window.outerHeight) {
					sm.classList.add("scrollable");
					sm.style.height = (window.outerHeight - sm.getBoundingClientRect().top - 32) + "px";
				}
			}
		});
	},100);

	window.addEventListener("resize", function() {
		onResize();
	});
	onResize();

	// Track file download clicks for Google Analytics
	document.addEventListener('click', function(e) {
		const link = e.target.closest('a');
		if (!link) return;
		
		const href = link.getAttribute('href');
		if (!href) return;
		
		const fileExtensions = /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|zip|rar|txt|csv|jpg|jpeg|png|gif|svg|mp4|mp3|avi|mov|wmv)$/i;
		if (fileExtensions.test(href)) {
			const filename = href.split('/').pop().split('?')[0];
			fireEvent('Download', 'click', filename);
		}
	});

	var fetchLinksFor = {
		cta: {
			label: 'CTA',
			selector: '#cta a'
		},
		socials: {
			label: 'Socials',
			selector: 'footer nav.social a'
		},
		startseite_topics: {
			label: 'Startseite Themen',
			selector: '#topics a',
			selector_label: '.h3'
		},
		startseite_boxes: {
			label: 'Startseite Boxen',
			selector: '#frontboxes a',
			selector_label: '.h3'
		},
		startseite_switches: {
			label: 'Startseite Switches',
			selector: '#news .switches a',
		},
		startseite_news: {
			label: 'Startseite News',
			selector: '#news .news.newsBoxes a.post',
			selector_label: '.h3'
		},
		startseite_blog: {
			label: 'Startseite Blog',
			selector: '#news .blog.newsBoxes a.post',
			selector_label: '.h3'
		},
		startseite_events: {
			label: 'Startseite Events',
			selector: '#news .events.newsBoxes a.post',
			selector_label: '.h3'
		},
		testimonials_nav_prev: {
			label: 'Testimonials Navigation',
			selector: '#testimonials .swiper-button-prev',
			selector_label: 'Previous'
		},
		testimonials_nav_next: {
			label: 'Testimonials Navigation',
			selector: '#testimonials .swiper-button-next',
			selector_label: 'Next'
		}
	};

	Object.values(fetchLinksFor).forEach(function(fetch,idx) {
		var label = fetch.label;
		var selector = fetch.selector;
		var selector_label = fetch.selector_label ? fetch.selector_label : null;
		document.querySelectorAll(selector).forEach(function(ctaLink) {
			if(selector_label) {
				var text = ctaLink.querySelector(selector_label) ? ctaLink.querySelector(selector_label).innerText : selector_label;
			} else {
				var text = ctaLink.innerText ? ctaLink.innerText : (ctaLink.getAttribute('alt') ? ctaLink.getAttribute('alt') : 'Unknown');
			}
			console.log('Setting up tracking for links:', selector, label, text);
			ctaLink.addEventListener('click', function() {
				fireEvent(label, 'click', text);
			});
		});
	});


});

